import { render } from "./IconCheckbox.vue?vue&type=template&id=2bc5d249"
import script from "./IconCheckbox.vue?vue&type=script&lang=ts"
export * from "./IconCheckbox.vue?vue&type=script&lang=ts"
script.render = render

export default script